import { SETPRELOADER_STATE } from '../mutation-types'

const state = {
  preloaderState: false,
  timer: 0,
  timeoutId: 0,
}

const mutations = {
  [SETPRELOADER_STATE](state, payload) {
    if (payload === false) {
      clearTimeout(state.timeoutId)
      state.preloaderState = payload
    } else {
      state.timeoutId = setTimeout(() => {
        state.preloaderState = payload
      }, state.timer)
    }
  }
}


export default {
  state,
  mutations,
}